import * as React from "react";
import { forwardRef } from "react";
const SvgUiArrowUp = ({
  title,
  titleId,
  ...props
}, ref) => <svg width={6} height={5} viewBox="0 0 6 5" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="m3 0 3 4.5H0z" fill="#726F7E" fillRule="evenodd" /></svg>;
const ForwardRef = forwardRef(SvgUiArrowUp);
export { ForwardRef as ReactComponent };